module.exports = __webpack_public_path__ + "img/wf-search.0a0768a5.svg";